import {
  ErrorMessage,
  errorMessages,
} from '@segurosvoluntarios_vel/lib-angular-components/src/sura-form';

export const ERROR_MESSAGES: ErrorMessage[] = [
  ...errorMessages,
  {
    key: 'ERROR_CREDIT_CARD',
    errorMessage: 'La tarjeta de crédito no es valida.',
  },
  {
    key: 'ERROR_SECURITY_CODE',
    errorMessage: 'Código inválido de seguridad.',
  },
];
